<template>
  <div class="edit-player">
    <div>
      <button @click="choosePhoto">Choose Photo</button>
      <input
        ref="fileInput"
        type="file"
        @change="fileSelected"
        capture="user"
        accept="image/*"
      />

      <button @click="takePhoto">Take Photo</button>
    </div>
    <WebcamBooth
      v-if="webcamActive"
      @cancel="webcamActive = false"
      @photo="photoTaken"
      :size="600"
    />
    <div v-else class="image-view">
      <div v-if="state == 'EMPTY'"></div>

      <div v-else-if="state == 'FRAMING'">
        <Cropper :src="sourceImage" ref="cropper" />
        <button @click="fix">Fix</button>
      </div>
      <div v-else-if="state == 'READY'">
        <div>
          <PlayerImage :src="croppedImage" ref="playerImage" />
        </div>
        <button @click="state = 'FRAMING'">Readjust</button>
        <button @click="save">Save</button>
      </div>
    </div>
    <button @click="cancel">Cancel</button>
  </div>
</template>

<script>
import WebcamBooth from "@/components/WebcamBooth.vue";
import Cropper from "@/components/Cropper.vue";
import PlayerImage from "@/components/PlayerImage.vue";
export default {
  components: {
    WebcamBooth,
    Cropper,
    PlayerImage,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      state: "EMPTY",
      sourceImage: "",
      croppedImage: null,
      webcamActive: false,
    };
  },
  methods: {
    choosePhoto() {
      this.$refs.fileInput.click();
    },
    fileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();

      reader.addEventListener("load", () => {
        this.sourceImage = reader.result;
        this.state = "FRAMING";
      });

      reader.readAsDataURL(file);
    },
    takePhoto() {
      this.webcamActive = true;
    },
    photoTaken(imageDataURL) {
      this.webcamActive = false;
      this.sourceImage = imageDataURL;
      this.state = "FRAMING";
    },
    async fix() {
      this.croppedImage = await this.$refs.cropper.getResult();
      this.state = "READY";
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      console.log(this.$refs.playerImage.landmarks);
      this.$store.commit("UPDATE_PLAYER", {
        id: this.id,
        sourceImage: this.sourceImage,
        croppedImage: this.croppedImage,
        landmarks: this.$refs.playerImage.getLandmarks(),
      });
      this.$emit("cancel");
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(newValue) {
        const player = this.$store.state.players.find(
          (player) => player.id == newValue
        );

        if (player) {
          this.sourceImage = player.sourceImage;
          this.croppedImage = player.croppedImage;
          this.state = "READY";
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  height: 400px;
  width: 400px;
  background-color: lightgray;
  margin: 0 auto;
  position: relative;
}

.image > * {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

input[type="file"] {
  display: none;
}

.image-view {
  display: flex;
  justify-content: center;
}
</style>
